import React from 'react';
import DividingLineImg from '@/assets/image/vip/dividing-line.png';
import { useAtom } from 'jotai';
import { curProductAtom, curTabAtom } from '@/store';
import { PromotionType, TabType } from '@/constants/subscription';

import styles from './index.module.css';
import { isWeb } from '@/utils/vip';

const Copywriting = () => {
  const [curTab] = useAtom(curTabAtom);
  const [curProduct] = useAtom(curProductAtom);

  const copywritingMap: {
    [key: string]: string[];
  } = {
    [TabType.SUB]: [
      curProduct?.checkBox?.giftExplain || '',
      curProduct?.checkBox?.vipGiftExplain || '',
      '个人商用授权',
    ],
    [TabType.MEIDOU]: ['AI商品图', 'AI Logo', '模特试衣'],
    [TabType.CUTOUT]: [
      '3秒一键抠图，效率翻倍',
      '“发丝级”处理，手术刀般精准',
      '保留商品轮廓，提升质感',
    ],
  };

  const title: {
    [key: string]: string;
  } = {
    [TabType.SUB]: `${isWeb ? 'VIP' : 'SVIP'}专属权益`,
    [TabType.MEIDOU]: '畅享AI功能',
    [TabType.CUTOUT]: '美图抠图',
  };

  return (
    <div className={styles.module}>
      <div className={styles.header}>
        <img className={styles.line} src={DividingLineImg} alt="" />
        <div className={styles.title}>{title[curTab || '']}</div>
        <img className={styles.line} src={DividingLineImg} alt="" />
      </div>
      <div className={styles.list}>
        {copywritingMap[curTab || '']?.map((item, index) =>
          item ? (
            <div key={index} className={styles.item}>
              {item}
            </div>
          ) : null
        )}
      </div>
    </div>
  );
};

export default React.memo(Copywriting);
